import React from 'react';
import { psychologistInfo } from '../mock/mockData';
import { Button } from './ui/button';
import { ArrowRight, Video } from 'lucide-react';

const HeroSection = () => {
  const handleBookingClick = () => {
    window.open(psychologistInfo.bookingLink, '_blank');
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={psychologistInfo.heroImage}
          alt="Psicologia Clínica"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-beige-50/95 via-rose-50/90 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-rose-200 mb-6 animate-fade-in">
            <Video className="h-4 w-4 text-rose-600" />
            <span className="text-sm font-medium text-rose-800">
              {psychologistInfo.consultationType}
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-rose-950 mb-6 leading-tight">
            {psychologistInfo.name}
          </h1>

          <h2 className="text-2xl sm:text-3xl text-rose-800 mb-8 font-light">
            {psychologistInfo.title}
          </h2>

          {/* Description */}
          <p className="text-lg sm:text-xl text-gray-700 mb-8 leading-relaxed max-w-2xl">
            Acompanhamento psicológico especializado para jovens adultos e adultos.
            Um espaço seguro e acolhedor para o seu bem-estar mental e emocional.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={handleBookingClick}
              size="lg"
              className="bg-gradient-to-r from-rose-500 to-rose-600 hover:from-rose-600 hover:to-rose-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              Marcar Consulta
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="border-2 border-rose-500 text-rose-700 hover:bg-rose-50 text-lg px-8 py-6"
            >
              Conhecer Serviços
            </Button>
          </div>

          {/* Stats or Trust Indicators */}
          <div className="mt-12 pt-12 border-t border-rose-200">
            <div className="grid grid-cols-3 gap-8">
              <div>
                <div className="text-3xl font-bold text-rose-600 mb-1">3+</div>
                <div className="text-sm text-gray-600">Anos de Experiência</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-rose-600 mb-1">100%</div>
                <div className="text-sm text-gray-600">Online</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-rose-600 mb-1">50min</div>
                <div className="text-sm text-gray-600">Por Sessão</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default HeroSection;
